import { IUser, Modify, UUID } from "src/app/core/interfaces";

export interface UserStateModel  {
  currentUser: Modify<IUser, { id: UUID }>
  allUsers: Modify<IUser, { id: UUID }>[]
}

export const generateDefaultUserState = (): UserStateModel => ({
  currentUser: {
    id: "",
    name: "",
    consentFirstName: "",
    consentLastName: "",
    consentEmail: "",
    email: "",
    orgId: "",
    skipTwoFactor: false,
    permissions: [],
    roles: ["Admin"],
    userType: null,
    stripeCustomerId: null,
    quickStartState: null,
    proAssociation: null,
  },
  allUsers: [],
});
